import * as React from 'react'
import {Box, PolymorphicComponentProps} from './Box'
import {Sprinkles} from '../sprinkles.css'

type StackOwnProps = {
  spacing?: Sprinkles['gap']
  direction?: Sprinkles['flexDirection']
  align?: Sprinkles['alignItems']
  justify?: Sprinkles['justifyContent']
}

export type StackProps<E extends React.ElementType> = PolymorphicComponentProps<E, StackOwnProps>

const defaultElement = 'div'

export const Stack: <E extends React.ElementType = typeof defaultElement>(
  props: StackProps<E>
) => React.ReactElement | null = React.forwardRef(
  <E extends React.ElementType = typeof defaultElement>(
    {
      spacing = '8px',
      align = 'stretch',
      justify = 'flex-start',
      direction = 'column',
      children,
      ...restProps
    }: StackProps<E>,
    ref: typeof restProps.ref
  ) => {
    return (
      <Box
        display="flex"
        flexDirection={direction}
        gap={spacing}
        alignItems={align}
        justifyContent={justify}
        ref={ref}
        {...restProps}
      >
        {children}
      </Box>
    )
  }
)
